import React from 'react'

const About = () => {
    return (
        <div id="about" className="max-w-screen-lg mx-auto">
            <figure class="md:flex bg-slate-100 rounded-xl p-8 md:p-0 dark:bg-slate-800">
                <img class="w-24 h-24 md:w-64 md:h-auto md:rounded-none rounded-full mx-auto" src='https://lh3.googleusercontent.com/a/ALm5wu0gKSbj-vrE-htx83t_56TBALi1t7_JwwWnxFh1gA=s96-c' alt="" width="384" height="512" />
                <div class="pt-6 md:p-8 text-center md:text-left space-y-4">
                    <blockquote>
                        <p class="text-lg font-medium">
                            A Full Stack Web developer with a passion for learning.I am always excited to do business with like minded people.I build
                                websites to make you successful in the long term.
      </p>
                    </blockquote>
                    <figcaption class="font-medium">
                        <div class="text-sky-500 dark:text-sky-400">
                            Arif ullah
      </div>
                        <div class="text-slate-700 dark:text-slate-500">
                            Chittagong, Bangladesh
      </div>
                    </figcaption>
                </div>
            </figure>
        </div>
    )
}

export default About
